jQuery(document).ready(function($) {
  $('.product-form__description .read-more-button').on('click', function() {
    $('.product-form__description').toggleClass('full-view');
  });

  // Product Addon
  var addonProperties = [];
  var addonIds = [];
  var addonPrice = 0;
  
  $('.addon-variant-option input[type=checkbox]').on('change', function() {
    var $this = $(this),
        addonName = $this.next('label').find('.swatch-label').text().trim().split(/[\s,\t,\n]+/).join(' '),
        originalPrice = parseFloat($('.price--large:not(.price--compare)').data('price'));

    if ( $this.prop('checked') ) {
      addonProperties.push(addonName);
      addonIds.push($this.data('variant-id'));
      addonPrice = addonPrice + parseFloat($this.data('variant-price'));
    } else {
      addonProperties = addonProperties.filter(function (name) {
        return name != addonName;
      });

      addonIds = addonIds.filter(function (id) {
        return id != $this.data('variant-id');
      });

      addonPrice = addonPrice - parseFloat($this.data('variant-price'));
    }

    $('input.addon-properties').val(addonProperties.join(', ')).removeAttr('disabled').trigger('change');
    $('input.addon-items-ids').val(addonIds.join(', ')).trigger('change');

    var plusPrice = addonPrice + originalPrice;
    $('.price--large:not(.price--compare)').text('$' + plusPrice.toFixed(2));
  });

  $('input.addon-properties').on('change', function() {
    var value = $(this).val();

    if ( ! value ) {
      $('input.addon-properties').attr('disabled', 'disabled');
    }
  });

  $(document).on('variant:changed', function(e) {
    var selectedVariant = e.originalEvent.detail.variant,
        price = selectedVariant.price,
        plusPrice = parseFloat(price / 100) + addonPrice,
        addtocartTxt = $('#AddToCart .loader-button__text').text();

    $('#AddonAddToCart .loader-button__text').text(addtocartTxt);
    $('.price--large:not(.price--compare)').attr('data-price', parseFloat(price / 100));

    if ( $('#AddToCart').prop('disabled') ) {
      $('#AddonAddToCart').addClass('disabled');
    } else {
      $('#AddonAddToCart').removeClass('disabled');
    }

    $('.price--large:not(.price--compare)').text('$' + plusPrice.toFixed(2));
  });

  $('#AddonAddToCart').on('click', function() {
    var $this = $(this),
        addonIdArr = $('input.addon-items-ids').val() ? $('input.addon-items-ids').val().split(', ') : [],
        addonCartItem = [];

    if ( $this.hasClass('disabled') ) return;
    
    if ( addonIdArr.length > 0 ) {
      for (let i = 0; i < addonIdArr.length; i++) {
        addonCartItem.push({
          id: addonIdArr[i],
          quantity: 1
        });
      }

      $this.addClass('loading');

      $.ajax({ // Add items to Cart
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: addonCartItem
        },
        dataType: 'json',
        success: function() {
          $('#AddToCart').click(); 
        }
      });
    } else {
      $('#AddToCart').click();
    }
  });

  $(document).on('cart:updated', function() {
    $('#AddonAddToCart').removeClass('loading');
  });
});